import http from "@/settings/apiSettings"

class MomenteCalculService {
    save(data: any) : Promise<any> {
        return http.clientResurseUmaneOdata.post("/SAL_MomenteCalcul", data)
    }
}
export default new MomenteCalculService()